export default __webpack_public_path__ + "static/media/Search_Icon.a28990f9.svg";